<template>
    <v-dialog v-model="openSearch" persistent transition="dialog-transition">
        <v-card>
            <v-toolbar dense dark color="secondary">
                <v-spacer></v-spacer>
                <v-toolbar-title>
                    Documents
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-container grid-list-xs>
                <v-row justify="center" v-if="type == 'Order'">
                    <v-col cols="1">
                        <div>OrderID</div>
                        {{ order.OrderID + ' ' + order.LoadNum + ' - '}} {{ order.LoadNumOrd == null ? 0 : order.LoadNumOrd }}
                    </v-col>
                    <v-col cols="2">
                        <div>TStart</div>
                        <p :style="order.TStartOrigin == 2 ?
                            'margin: 0;padding: 2px 0 0;width: 140px;background-color: #80D8A6;' :
                            order.TStartOrigin == 3 ?
                                'margin: 0;padding: 2px 0 0;width: 140px;background-color: #80D8D5;' :
                                'margin: 0;padding: 2px 0 0;width: 140px;'
                            ">{{ order.TStart }} <strong class="timeLoadValue">
                                {{ order.TStartTime }}
                            </strong></p>
                    </v-col>
                    <v-col cols="2">
                        <div>TEnd</div>
                        <p :style="order.TEndOrigin == 2 ?
                            'margin: 0;padding: 2px 0 0;width: 140px;background-color: #80D8A6;' :
                            order.TEndOrigin == 3 ?
                                'margin: 0;padding: 2px 0 0;width: 140px;background-color: #80D8D5;' :
                                'margin: 0;padding: 2px 0 0;width: 140px;'
                            ">{{ order.TEnd }} <strong class="timeLoadValue">
                                {{ order.TEndTime }}
                            </strong> </p>
                    </v-col>
                    <v-col cols="2">
                        <div>StStart</div>
                        <p :style="order.StStartOrigin == 2 ?
                            'margin: 0;padding: 2px 0 0;width: 140px;background-color: #80D8A6;' :
                            order.StStartOrigin == 3 ?
                                'margin: 0;padding: 2px 0 0;width: 140px;background-color: #80D8D5;' :
                                'margin: 0;padding: 2px 0 0;width: 140px;'
                            ">{{ order.StStart }} <strong class="timeLoadValue">
                                {{ order.StStartTime }}
                            </strong></p>
                    </v-col>
                    <v-col cols="2">
                        <div>StEnd</div>
                        <p :style="order.StEndOrigin == 2 ?
                            'margin: 0;padding: 2px 0 0;width: 140px;background-color: #80D8A6;' :
                            order.StEndOrigin == 3 ?
                                'margin: 0;padding: 2px 0 0;width: 140px;background-color: #80D8D5;' :
                                'margin: 0;padding: 2px 0 0;width: 140px;'
                            ">{{ order.StEnd }} <strong class="timeLoadValue">
                                {{ order.StEndTime }}
                            </strong></p>
                    </v-col>
                </v-row>
                <v-row v-else>
                    <v-col>
                        <div>ShiftStartTime</div>
                        <p>{{ order.shift_detail.ShiftStartTime }}</p>
                    </v-col>
                    <v-col>
                        <div>GPSShiftStart</div>
                        <p>{{ order.shift_detail.GPSShiftStart }}</p>
                    </v-col>
                    <v-col>
                        <div>GPSShiftEnd</div>
                        <p>{{ order.shift_detail.GPSShiftEnd }}</p>
                    </v-col>
                    <v-col>
                        <div>ShiftEndTime</div>
                        <p>{{ order.shift_detail.ShiftEndTime }}</p>
                    </v-col>
                </v-row>
                <v-row>
                        <v-col>
                            <v-toolbar dense dark flat height="35" color="secondary" class="white--text">
                            <v-spacer></v-spacer>
                            <v-toolbar-title style="font-size: large;">
                                Document Viewer
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-data-iterator :items="document" :page="page" :items-per-page="1" hide-default-footer>
                            <template v-slot:default="props">
                                <v-container v-for="(it, id) in props.items" :key="'document' + id"
                                    style="background-color: #fff;" fluid>
                                    <iframe :src="it.Link" style="width: 100%; height:70vh ;"></iframe>
                                    <v-pagination v-model="page" :length="document.length" prev-icon="mdi-menu-left"
                                        next-icon="mdi-menu-right"></v-pagination>
                                </v-container>
                            </template>
                        </v-data-iterator>
                        </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from "axios";
export default {
    props: ['openSearch', 'order','type'],
    data: function () {
        return {
            page:1,
            document: [],
        }
    },
    methods: {
        loadOrder: async function () {
            var parms = null;
            if(this.type == 'Order'){
                parms = this.order.OrderID;   
            }else{
                parms = this.order.ShiftDetail;   
            }
            try {
                let response = await axios.get('order/documents/by/order/' + parms, {
                    //Just chage router Api
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                });
                this.document = response.data;
                console.log(this.document);
            } catch (error) {
                console.log(error);
            }
        },
    },
    mounted() {
        this.loadOrder();
    }
}
</script>